import { __awaiter, __extends, __generator } from "tslib";
import Manager from '../Abstracts/Manager';
import Axios from 'axios';
var HttpManager = /** @class */ (function (_super) {
    __extends(HttpManager, _super);
    /* CONSTRUCTOR */
    function HttpManager(url, token, authManager) {
        var _this = _super.call(this) || this;
        /* METHODS */
        _this.handleNotFound = function () { };
        _this.handleUnauthorized = function () { };
        _this.handleSomethingWentWrong = function () { };
        _this._url = url;
        _this._config = {
            headers: {}
        };
        _this._token = token;
        _this._authManager = authManager;
        _this.callbackRefreshToken();
        return _this;
    }
    HttpManager.prototype.addCustomHeader = function (key, value) {
        this._config.headers[key] = value;
    };
    HttpManager.prototype.get = function (route, parameters) {
        if (parameters === void 0) { parameters = []; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, urlParameters;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._config.headers;
                        return [4 /*yield*/, this.retrieveToken()];
                    case 1:
                        _a.Authorization = _b.sent();
                        urlParameters = this.handleParams(parameters);
                        return [4 /*yield*/, Axios.get(this._url + "/" + route + urlParameters, this._config).catch(function (error) { _this.handleError(error); })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    HttpManager.prototype.post = function (route, parameters, object) {
        if (parameters === void 0) { parameters = []; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, urlParameters;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._config.headers;
                        return [4 /*yield*/, this.retrieveToken()];
                    case 1:
                        _a.Authorization = _b.sent();
                        urlParameters = this.handleParams(parameters);
                        return [4 /*yield*/, Axios.post(this._url + "/" + route + urlParameters, object, this._config).catch(function (error) { _this.handleError(error); })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    HttpManager.prototype.put = function (route, parameters, object) {
        if (parameters === void 0) { parameters = []; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, urlParameters;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._config.headers;
                        return [4 /*yield*/, this.retrieveToken()];
                    case 1:
                        _a.Authorization = _b.sent();
                        urlParameters = this.handleParams(parameters);
                        return [4 /*yield*/, Axios.put(this._url + "/" + route + urlParameters, object, this._config).catch(function (error) { _this.handleError(error); })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    HttpManager.prototype.delete = function (route, parameters) {
        if (parameters === void 0) { parameters = []; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, urlParameters;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._config.headers;
                        return [4 /*yield*/, this.retrieveToken()];
                    case 1:
                        _a.Authorization = _b.sent();
                        urlParameters = this.handleParams(parameters);
                        return [4 /*yield*/, Axios.delete(this._url + "/" + route + urlParameters, this._config).catch(function (error) {
                                _this.handleError(error);
                            })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    HttpManager.prototype.callbackRefreshToken = function () {
        var _this = this;
        Axios.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(error && error.config && error.response && error.response.status === 401)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._authManager.handleUnauthorized().then(function (token) { return __awaiter(_this, void 0, void 0, function () {
                                var log;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            error.config.headers['Authorization'] = 'Bearer ' + token;
                                            return [4 /*yield*/, Axios.request(error.config)];
                                        case 1:
                                            log = _a.sent();
                                            if (log != undefined && log.status !== 200) {
                                                return [2 /*return*/, this._authManager.handleNoTokenFound()];
                                            }
                                            return [2 /*return*/, log];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); });
    };
    HttpManager.prototype.retrieveToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._token()];
                    case 1:
                        token = _b.sent();
                        if (token == undefined) {
                            return [2 /*return*/, ''];
                        }
                        return [2 /*return*/, token];
                    case 2:
                        _a = _b.sent();
                        console.warn("For token usage, please send a string-type");
                        return [2 /*return*/, ''];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HttpManager.prototype.handleError = function (error) {
        if (error.response != undefined) {
            switch (error.response.status) {
                case 404:
                    this.handleNotFound(error);
                    break;
                case 401:
                    this.handleUnauthorized(error);
                    break;
                default:
                    this.handleSomethingWentWrong(error);
                    break;
            }
        }
        else {
            this.handleSomethingWentWrong(error);
        }
    };
    HttpManager.prototype.handleParams = function (parameters) {
        var params = "";
        if (parameters.length > 0) {
            for (var i = 0; i < parameters.length; i++) {
                if (i == 0) {
                    params += "?" + parameters[i].key + "=" + parameters[i].value;
                }
                else {
                    params += "&" + parameters[i].key + "=" + parameters[i].value;
                }
            }
        }
        return params;
    };
    HttpManager.prototype.isConnected = function (route, callbackConnected, callbackNotConnected, callbackError) {
        if (route === void 0) { route = 'Ping'; }
        if (callbackNotConnected === void 0) { callbackNotConnected = function () { }; }
        if (callbackError === void 0) { callbackError = function () { }; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._config.headers.Authorization = this.retrieveToken();
                        return [4 /*yield*/, Axios.get(this._url + "/" + route, this._config).then(function (response) {
                                if (response) {
                                    if (response.data === true) {
                                        callbackConnected();
                                    }
                                    else {
                                        callbackNotConnected();
                                    }
                                }
                                else {
                                    callbackError(response);
                                }
                            }).catch(function (error) { callbackError(error); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return HttpManager;
}(Manager));
export default HttpManager;
